import { Link } from 'react-router-dom';

export default function UeberUnsCTA() {
  return (
    <section className="py-20 sm:py-24 bg-[#f5f1eb]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/dc823c93378aebb2ee1876e90a84801a.jpg"
            alt="IGM Projekte"
            className="w-full h-[400px] sm:h-80 object-cover object-top"
          />
          {/* Mobile: full dark overlay; Desktop: side gradient */}
          <div className="absolute inset-0 bg-[#0D2B4E]/80 sm:bg-transparent" />
          <div className="absolute inset-0 hidden sm:block bg-gradient-to-r from-[#0D2B4E]/92 via-[#0D2B4E]/75 to-[#0D2B4E]/20" />
          <div className="absolute inset-0 flex items-center">
            <div className="px-6 sm:px-12 max-w-2xl">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 drop-shadow-md">
                Lernen Sie uns persönlich kennen
              </h2>
              <p className="text-white/95 text-sm sm:text-base lg:text-lg leading-relaxed mb-8 drop-shadow">
                Sprechen Sie mit unserem Team — kostenlos, unverbindlich und direkt. Wir freuen uns
                auf Ihr Projekt.
              </p>
              <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 bg-white text-[#0D2B4E] px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-send-line" />
                  </div>
                  Kontakt aufnehmen
                </Link>
                <Link
                  to="/projekte"
                  className="inline-flex items-center gap-2 border border-white/40 text-white px-6 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-image-line" />
                  </div>
                  Unsere Projekte
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
